import React, { FC }                        from "react";
import { useDrag }                          from "react-dnd";
import { useDispatch }                      from "react-redux";
import { Button, Card, Form, Input, Radio } from "semantic-ui-react";
import RecordTemplateRepository             from "../../../../../domain/record/template/RecordTemplateRepository";
import WidgetItem                           from "../../../../../domain/record/widget/item/WidgetItem";
import WidgetItemTitle                      from "../../../../../domain/record/widget/item/WidgetItemTitle";
import Widget                               from "../../../../../domain/record/widget/Widget";
import WidgetTitle                          from "../../../../../domain/record/widget/WidgetTitle";
import WidgetType                           from "../../../../../domain/record/widget/WidgetType";
import RecordTemplateDataSource
                                            from "../../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import WidgetProps                          from "../WidgetProps";

const calcNextWidth = (widget: Widget): number => {
  const dropArea: HTMLElement | null = document.getElementById("dropArea");
  let nextWidth: number = 0;
  if (dropArea !== null) {
    widget.items.toList().forEach((_, index) => {
      if (index > 0 && nextWidth + 318 + 290 + widget.coordinate.x < dropArea.clientWidth) {
        nextWidth += 290;
      }
    });
  }
  return nextWidth;
};

const DropAreaRadioHorizontalWidget: FC<WidgetProps> = (props: WidgetProps) => {
  const repository: RecordTemplateRepository = new RecordTemplateDataSource(useDispatch());
  const [{isDragging}, drag] = useDrag({
    item: {widgetIndex: props.widgetIndex, type: WidgetType.RADIO_HORIZONTAL},
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  const {widgetIndex, widget} = props;
  return (
    <>
      <div
        ref={ drag }
        style={ {
          opacity: isDragging ? 0.5 : 1,
          cursor: "move",
          position: "absolute",
          left: widget.coordinate.x + "px",
          top: widget.coordinate.y + "px"
        } }
      >
        <Card style={ {width: `${ 318 + calcNextWidth(widget) }px`} }>
          <Card.Content>
            <Card.Header>
              <Input
                style={ {height: "33.5px", width: "242px"} }
                defaultValue={ widget.title.value }
                onChange={ (event, data) => repository.setWidgetTitle(widgetIndex, new WidgetTitle(data.value)) }
                placeholder="タイトルを入力"
              />
              <Button
                style={ {height: "33.5px", marginLeft: "5px"} }
                icon="close"
                onClick={ () => repository.deleteWidget(widgetIndex) }
              />
            </Card.Header>
            <Button
              style={ {height: "33.5px"} }
              icon="plus"
              onClick={ () => repository.addWidgetItem(widgetIndex, new WidgetItem()) }
            />
            <Form>
              {
                widget.items.toList().map((item, widgetItemIndex) => (
                  <>
                    <Radio name={ `${ widgetItemIndex }` } disabled/>
                    <Input
                      style={ {height: "33.5px", width: "225px"} }
                      placeholder="項目名を入力"
                      value={ item.title.value }
                      onChange={ (event, data) => repository.setWidgetItemTitle(widgetIndex, widgetItemIndex, new WidgetItemTitle(data.value)) }
                    />
                    <Button
                      style={ {height: "33.5px", marginLeft: "5px"} }
                      icon="close"
                      onClick={ () => repository.deleteWidgetItem(widgetIndex, widgetItemIndex) }
                    />
                  </>
                ))
              }
            </Form>
          </Card.Content>
        </Card>
      </div>
    </>
  );
};

export default DropAreaRadioHorizontalWidget;
